import { h } from 'preact';
import React, { Component } from 'react';
import { isActionAllowed } from '../../../util';

export default class Switch extends Component {
  state = {
    isPurModelChecked: false,
    toggleDisplay: true,
  };

  toggle = (e, shouldCheck) => {
    const { value } = this.props;
    const isChecked = shouldCheck !== undefined ? shouldCheck : !this.props.checked;
    if (value.childCategories) {
      this.props.toggleStack(e, value, isChecked);
    } else {
      this.props.toggleCategory(e, value._id, value.isNegative ? !isChecked : isChecked);
    }

    this.setState({ checked: isChecked });
  }

  // componentDidMount = () => {
  //   if(this.props.usePurModel){
  //     this.toggle(true);
  //   };
  // };

  // componentDidUpdate = (prevProps, prevState) => {
  //   if(this.props.usePurModel !== prevProps.usePurModel){
  //     this.setState({isPurModelChecked: this.props.usePurModel, toggleDisplay: !this.state.toggleDisplay}, () => {
  //       if (!this.props.selectedLi) {
  //         this.toggle(this.state.isPurModelChecked);
  //       }; 
  //     });
  //   } ;
  // };
  
  render() {
    const {
      type,
      color,
      offColor,
      text,
      offText,
      colorActive,
      offActiveColor,
      checked,
      value: { name: ariaLabel },
      locked,
      tabbable
    } = this.props;


    // const isToggleOn = !this.props.usePurModel || this.state.toggleDisplay && !this.props.usePurModel ? 'inline-flex' : 'none';
    const neutral = (
      <button
        className={locked ? "pm-toggle locked" : "pm-toggle"}
        tabIndex="0"
        type="button"
        role="switch"
        aria-checked={checked ? "true" : "false"}
        onKeyDown={(e) => isActionAllowed(e.key) && this.toggle(e, !checked ? true : false)}
        // style={{ display: isToggleOn}}
      >
        <span
          className="off"
          style={{
            backgroundColor: !checked ? offColor : 'transparent',
            color: !checked ? offActiveColor : '#000000',
            borderColor: !checked ? offColor : '#dddddd',
          }}
          onClick={(e) => this.toggle(e, false)}
        >
          {offText}
        </span>
        <span
          className="on"
          style={{
            backgroundColor: checked ? color : 'transparent',
            color: checked ? colorActive : '#000000',
            borderColor: checked ? color : '#dddddd',
          }}
          onClick={(e) => this.toggle(e, true)}
        >
          {text}
        </span>
      </button>
    );

    const basicClassName = checked ? 'pm-switch checked' : 'pm-switch';

    const basic = (
      <button
        tabIndex="0"
        type="button"
        role="switch"
        aria-checked={checked ? "true" : "false"}
        className={locked ? basicClassName + ' locked' : basicClassName}
        onKeyDown={(e) => {
          e.stopPropagation();
          isActionAllowed(e.key) && this.toggle();
        }}
        // style={{ display: isToggleOn}}
      >
        <span className="slider round"  style={{ backgroundColor: checked ? color : offColor }} onClick={() => this.toggle()}></span>
      </button>
    );

    return type === 'neutral' ? neutral : basic;
  }
}
